import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IComment } from '@/Module/Comment/Model/DataModel';
import { commentGetListAction, createCommentAction } from '@/Module/Comment/Store/Action';
import { commentAdapter } from '@/Module/Comment/Store/Adapter';

const CommentSlice = createSlice({
  name: 'comment',
  initialState: commentAdapter.getInitialState({
    isLoading: false,
    createIsLoading: false,
    page: 1,
    pageRows: 3,
    total: 0,
    replyId: null as null | IComment['id'],
  }),
  reducers: {
    nextPage: state => {
      state.page += 1;
    },
    setReplyId: (state, { payload }: PayloadAction<null | IComment['id']>) => {
      state.replyId = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(commentGetListAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(commentGetListAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(commentGetListAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.total = payload.total;

        if (state.page === 0) {
          commentAdapter.setAll(state, payload.data);
        } else {
          commentAdapter.addMany(state, payload.data);
        }
      });

    builder
      .addCase(createCommentAction.pending, state => {
        state.createIsLoading = true;
      })
      .addCase(createCommentAction.rejected, state => {
        state.createIsLoading = false;
      })
      .addCase(createCommentAction.fulfilled, state => {
        state.createIsLoading = false;
      });
  },
});

export const { nextPage: commentNextPageAction, setReplyId: commentSetReplyIdAction } = CommentSlice.actions;

export default CommentSlice;
